(function () {
  'use strict';

  // ─── SET THIS to your deployed Cloudflare Worker URL ─────────────────────
  var FAKTURA_WORKER_URL = 'https://faktura-proxy.ivan-f0e.workers.dev';
  // ─────────────────────────────────────────────────────────────────────────

  var BRREG_API     = 'https://data.brreg.no/enhetsregisteret/api/enheter/';
  var DEBOUNCE_MS   = 600;
  var SAVE_DEBOUNCE = 400;
  var TOTAL_STEPS   = 3;

  var FIELD_MAP = {
    'faktura-orgnr':         'Organisasjonsnummer',
    'faktura-firmanavn':     'Firmanavn',
    'faktura-adresse':       'Fakturaadresse',
    'faktura-postnummer':    'Postnummer',
    'faktura-poststed':      'Poststed',
    'faktura-kontaktperson': 'Kontaktperson',
    'faktura-epost':         'Faktura e-post',
    'faktura-referanse':     'Referanse',
  };

  // Required field IDs that must be filled before advancing from each step.
  var STEP_REQUIRED = {
    1: [],
    2: ['faktura-adresse', 'faktura-postnummer', 'faktura-poststed', 'faktura-kontaktperson', 'faktura-epost'],
    3: [],
  };

  var saveTimer   = null;
  var orgnrTimer  = null;
  var currentStep = 1;

  function val(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : '';
  }

  // ── Org number local validation (mod-11 checksum) ─────────────────────────
  function localValidateOrgnr(orgnr) {
    if (!/^\d{9}$/.test(orgnr)) return false;
    var weights = [3, 2, 7, 6, 5, 4, 3, 2];
    var sum = 0;
    for (var i = 0; i < 8; i++) sum += parseInt(orgnr[i]) * weights[i];
    var rem     = sum % 11;
    var control = rem === 0 ? 0 : 11 - rem;
    if (control === 10) return false;
    return control === parseInt(orgnr[8]);
  }

  // ── Payment method ─────────────────────────────────────────────────────────
  function getCurrentMethod() {
    var btn = document.getElementById('faktura-btn-faktura');
    return (btn && btn.getAttribute('aria-pressed') === 'true') ? 'faktura' : 'now';
  }

  function selectMethod(method) {
    var btnNow      = document.getElementById('faktura-btn-now');
    var btnFaktura  = document.getElementById('faktura-btn-faktura');
    var section     = document.getElementById('faktura-fields-section');
    var dynCheckout = document.getElementById('faktura-dynamic-checkout');

    if (btnNow)    btnNow.setAttribute('aria-pressed',    method === 'now'     ? 'true' : 'false');
    if (btnFaktura) btnFaktura.setAttribute('aria-pressed', method === 'faktura' ? 'true' : 'false');

    if (section) {
      section.style.display = method === 'faktura' ? '' : 'none';
      if (method === 'faktura') {
        goToStep(1);
        setTimeout(function () { section.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
      }
    }

    if (dynCheckout) dynCheckout.style.display = method === 'now' ? '' : 'none';

    fetch('/cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ attributes: { Betalingsmetode: method === 'faktura' ? 'faktura' : '' } }),
    }).catch(function (e) { console.error('[faktura] method save', e); });

    updateCheckout();
  }

  // ── Step management ────────────────────────────────────────────────────────
  function goToStep(n) {
    currentStep = n;

    for (var s = 1; s <= TOTAL_STEPS; s++) {
      var panel = document.getElementById('faktura-step-' + s);
      if (panel) panel.style.display = s === n ? '' : 'none';
    }

    document.querySelectorAll('.faktura-step-dot').forEach(function (dot) {
      var step = parseInt(dot.dataset.step);
      dot.classList.toggle('is-active', step === n);
      dot.classList.toggle('is-done',   step < n);
    });

    var label = document.getElementById('faktura-step-label');
    if (label) label.textContent = 'Steg ' + n + ' av ' + TOTAL_STEPS;

    updateCheckout();
  }

  function scrollToForm() {
    var section = document.getElementById('faktura-fields-section');
    if (section) setTimeout(function () { section.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 30);
  }

  function validateStep(n) {
    var fields = STEP_REQUIRED[n] || [];
    var firstEmpty = null;
    var ok = true;
    for (var i = 0; i < fields.length; i++) {
      var el   = document.getElementById(fields[i]);
      var wrap = el ? el.closest('.field') : null;
      if (!el || !el.value.trim()) {
        ok = false;
        if (wrap) wrap.classList.add('field--error');
        if (!firstEmpty) firstEmpty = el;
      } else {
        if (wrap) wrap.classList.remove('field--error');
      }
    }
    if (firstEmpty) setTimeout(function () { firstEmpty.focus(); }, 50);
    return ok;
  }

  // ── Cart attribute persistence ─────────────────────────────────────────────
  function collectAttrs() {
    var attrs = {};
    Object.keys(FIELD_MAP).forEach(function (id) {
      var el = document.getElementById(id);
      if (el) attrs[FIELD_MAP[id]] = el.value.trim();
    });
    var cb = document.getElementById('faktura-godtar');
    attrs['Faktura godtatt'] = (cb && cb.checked) ? 'ja' : '';
    return attrs;
  }

  function saveToCart() {
    fetch('/cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ attributes: collectAttrs() }),
    }).catch(function (e) { console.error('[faktura] save', e); });
  }

  function scheduleSave() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(saveToCart, SAVE_DEBOUNCE);
  }

  // ── Checkout gate ──────────────────────────────────────────────────────────
  function canCheckout() {
    if (!document.getElementById('faktura-form-wrapper')) return true;
    return getCurrentMethod() !== 'faktura';
  }

  function updateCheckout() {
    var isFaktura = getCurrentMethod() === 'faktura';

    // Hide/show the standard Shopify checkout button
    var drawerBtn = document.getElementById('CartDrawer-Checkout');
    if (drawerBtn) drawerBtn.style.display = isFaktura ? 'none' : '';

    document.querySelectorAll('.cart__checkout-button').forEach(function (btn) {
      btn.style.display = isFaktura ? 'none' : '';
    });

    // Enable "Send faktura" only on step 3 with checkbox ticked
    var sendBtn = document.getElementById('faktura-send-btn');
    if (sendBtn) {
      var cb = document.getElementById('faktura-godtar');
      sendBtn.disabled = !(isFaktura && currentStep === 3 && cb && cb.checked);
    }

    if (!isFaktura) setCheckoutMsg('');
  }

  // ── Invoice submission ─────────────────────────────────────────────────────
  function submitFaktura() {
    var sendBtn = document.getElementById('faktura-send-btn');
    if (sendBtn) { sendBtn.disabled = true; sendBtn.textContent = 'Sender\u2026'; }
    setCheckoutMsg('');

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) throw new Error('Handlekurven er tom.');
        return fetch(FAKTURA_WORKER_URL, {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items:         cart.items.map(function (i) { return { variant_id: i.variant_id, quantity: i.quantity }; }),
            orgnr:         val('faktura-orgnr'),
            firmanavn:     val('faktura-firmanavn'),
            adresse:       val('faktura-adresse'),
            postnummer:    val('faktura-postnummer'),
            poststed:      val('faktura-poststed'),
            kontaktperson: val('faktura-kontaktperson'),
            epost:         val('faktura-epost'),
            referanse:     val('faktura-referanse'),
          }),
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.success) throw new Error(data.error || 'Ukjent feil');
        fetch('/cart/clear.js', { method: 'POST' }).catch(function () {});
        var submitState  = document.getElementById('faktura-submit-state');
        var successState = document.getElementById('faktura-success-state');
        if (submitState)  submitState.style.display  = 'none';
        if (successState) successState.style.display = '';
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'faktura-form' });
        }
      })
      .catch(function (err) {
        console.error('[faktura] submit failed', err);
        setCheckoutMsg(err.message || 'Noe gikk galt — prøv igjen eller kontakt oss.');
        if (sendBtn) { sendBtn.disabled = false; sendBtn.textContent = 'Send faktura'; }
      });
  }

  function setCheckoutMsg(text) {
    var msg = document.getElementById('faktura-checkout-msg');
    if (msg) msg.textContent = text;
  }

  // ── Org number field ───────────────────────────────────────────────────────
  function initOrgnrField() {
    var input  = document.getElementById('faktura-orgnr');
    var status = document.getElementById('faktura-orgnr-status');
    var firma  = document.getElementById('faktura-firmanavn');

    if (!input || input.dataset.fakturaBound) return;
    input.dataset.fakturaBound = 'true';

    if (input.value && localValidateOrgnr(input.value)) {
      input.dataset.orgnrValidated = 'true';
      if (status) { status.textContent = '\u2713 Gyldig'; status.style.color = 'green'; }
    }

    input.addEventListener('input', function () {
      var raw = input.value.replace(/\D/g, '');
      input.value = raw;
      clearTimeout(orgnrTimer);
      delete input.dataset.orgnrValidated;

      if (!raw) { if (status) status.textContent = ''; return; }
      if (!localValidateOrgnr(raw)) {
        if (status) { status.textContent = raw.length === 9 ? 'Ugyldig organisasjonsnummer.' : ''; status.style.color = 'red'; }
        return;
      }
      if (status) { status.textContent = 'Validerer\u2026'; status.style.color = 'inherit'; }
      orgnrTimer = setTimeout(function () { validateOrgnrRemote(raw); }, DEBOUNCE_MS);
    });
  }

  function validateOrgnrRemote(orgnr) {
    var input  = document.getElementById('faktura-orgnr');
    var status = document.getElementById('faktura-orgnr-status');
    var firma  = document.getElementById('faktura-firmanavn');

    fetch(BRREG_API + orgnr, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (r.status === 404) { if (status) { status.textContent = 'Org.nr ikke funnet.'; status.style.color = 'red'; } return null; }
        if (!r.ok)            { if (status) { status.textContent = 'Validering feilet.'; status.style.color = 'red'; } return null; }
        return r.json();
      })
      .then(function (data) {
        if (!data) return;
        if (data.slettedato) {
          if (status) { status.textContent = '\u00ab' + data.navn + '\u00bb er slettet.'; status.style.color = 'red'; }
          return;
        }
        if (input) input.dataset.orgnrValidated = 'true';
        if (status) { status.textContent = '\u2713 ' + data.navn; status.style.color = 'green'; }
        if (firma && !firma.value.trim()) firma.value = data.navn;
        scheduleSave();
      })
      .catch(function (e) {
        if (status) { status.textContent = 'Nettverksfeil.'; status.style.color = 'red'; }
        console.error('[faktura] orgnr', e);
      });
  }

  // ── Form field initialiser ─────────────────────────────────────────────────
  // Only binds inputs + checkbox — buttons use document delegation (see bindButtons).
  function initFakturaForm() {
    if (!document.getElementById('faktura-form-wrapper')) return;

    // Sync dynamic checkout visibility on re-render
    var dynCheckout = document.getElementById('faktura-dynamic-checkout');
    if (dynCheckout) dynCheckout.style.display = getCurrentMethod() === 'now' ? '' : 'none';

    // Re-bind invoice text/email fields
    Object.keys(FIELD_MAP).forEach(function (id) {
      if (id === 'faktura-orgnr') return;
      var el = document.getElementById(id);
      if (!el || el.dataset.fakturaBound) return;
      el.dataset.fakturaBound = 'true';
      el.addEventListener('input', function () {
        var wrap = this.closest('.field');
        if (wrap) wrap.classList.remove('field--error');
        scheduleSave();
        updateCheckout();
      });
    });

    // Re-bind checkbox
    var cb = document.getElementById('faktura-godtar');
    if (cb && !cb.dataset.fakturaBound) {
      cb.dataset.fakturaBound = 'true';
      cb.addEventListener('change', function () { scheduleSave(); updateCheckout(); });
    }

    // Re-bind org number field
    initOrgnrField();

    // Auto-advance to step 3 if returning customer has everything pre-filled;
    // otherwise preserve whichever step the user is currently on.
    var allFilled = STEP_REQUIRED[2].every(function (id) { return !!val(id); });
    var targetStep = (allFilled && cb && cb.checked && getCurrentMethod() === 'faktura') ? 3 : currentStep;
    goToStep(targetStep);

    updateCheckout();
  }

  window.initFakturaForm = initFakturaForm;

  // ── Document-level button delegation ──────────────────────────────────────
  // Bound ONCE at boot — survives all cart re-renders because it lives on document.
  function bindButtons() {
    document.addEventListener('click', function (e) {

      // ── Payment method toggle ─────────────────────────────────────────────
      var methodBtn = e.target.closest('#faktura-btn-now, #faktura-btn-faktura');
      if (methodBtn) { selectMethod(methodBtn.dataset.method); return; }

      // ── Step: Next 1 → 2 ─────────────────────────────────────────────────
      if (e.target.closest('#faktura-next-1')) {
        if (validateStep(1)) { scheduleSave(); goToStep(2); scrollToForm(); }
        return;
      }

      // ── Step: Next 2 → 3 ─────────────────────────────────────────────────
      if (e.target.closest('#faktura-next-2')) {
        if (validateStep(2)) { scheduleSave(); goToStep(3); scrollToForm(); }
        return;
      }

      // ── Step: Back 2 → 1 ─────────────────────────────────────────────────
      if (e.target.closest('#faktura-prev-2')) { goToStep(1); scrollToForm(); return; }

      // ── Step: Back 3 → 2 ─────────────────────────────────────────────────
      if (e.target.closest('#faktura-prev-3')) { goToStep(2); scrollToForm(); return; }

      // ── Send faktura ──────────────────────────────────────────────────────
      if (e.target.closest('#faktura-send-btn')) {
        var btn = document.getElementById('faktura-send-btn');
        if (btn && !btn.disabled) submitFaktura();
        return;
      }
    });
  }

  // ── Cart Drawer hook ───────────────────────────────────────────────────────
  function hookCartDrawer() {
    // Wait until the cart-drawer custom element is fully defined — avoids the
    // timing race where faktura-form.js loads before cart-drawer.js.
    customElements.whenDefined('cart-drawer').then(function () {
      var cartDrawerEl = document.querySelector('cart-drawer');
      if (!cartDrawerEl || cartDrawerEl.dataset.fakturaHooked) return;
      cartDrawerEl.dataset.fakturaHooked = 'true';

      var original = cartDrawerEl.renderContents.bind(cartDrawerEl);
      cartDrawerEl.renderContents = function (parsedState) {
        original(parsedState);
        setTimeout(initFakturaForm, 100);
      };

      // Safety net: block checkout button click in faktura mode
      var drawerEl = document.getElementById('CartDrawer');
      if (drawerEl) {
        drawerEl.addEventListener('click', function (e) {
          var btn = e.target.closest('#CartDrawer-Checkout');
          if (!btn || canCheckout()) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
          return false;
        }, true);
      }
    });
  }

  // ── Cart Page hook ─────────────────────────────────────────────────────────
  function hookCartPage() {
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(initFakturaForm, 100);
      });
    }

    var cartForm = document.getElementById('cart');
    if (cartForm) {
      cartForm.addEventListener('submit', function (e) {
        if (!e.submitter || e.submitter.name !== 'checkout') return;
        if (canCheckout()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }, true);
    }
  }

  // ── Boot ───────────────────────────────────────────────────────────────────
  function boot() {
    bindButtons();     // Once — survives all re-renders
    initFakturaForm(); // Bind fields + set initial state
    hookCartDrawer();  // Patch renderContents after element is defined
    hookCartPage();    // PubSub + form submit guard
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
